// Producer model
export interface Producer {
    legalName: string;
    relationship: string;
    otherRelationship: string;
    contact: string;
    role: string;
    email: string;
    addressLines: string;
    city: string;
    state: string;
    zip: string;
    telephone: string;
    fax: string;
    taxId: string;
    taxType: string;
    owners?: Owner[];
    fullAddress?: string;
  }
  
  // Owner model
  export interface Owner {
    legalName: string;
    email: string;
    taxId: string;
    addressLines: string;
    city: string;
    state: string;
    zip: string;
    percentOwned: number;
    familyRelation: string;
    fullAddress?: string;
  }

  export function createDefaultOwner(): Owner {
    return {
        legalName: "",
        email: "",
        taxId: "",
        addressLines: "",
        city: "",
        state: "",
        zip: "",
        percentOwned: 0,
        familyRelation: ""
    };
}

export function createDefaultProducer(): Producer {
    return {
        legalName: "",
        relationship: "",
        otherRelationship: "",
        contact: "",
        role: "",
        email: "",
        addressLines: "",
        city: "",
        state: "",
        zip: "",
        telephone: "",
        fax: "",
        taxId: "",
        taxType: "",
        owners: [createDefaultOwner()]
    };
}